import * as React from 'react';
import { cn } from '@relay-towing/tokens';
import { mapClusterRecipe } from '../recipes/map.recipe';

/** From this many calls the bubble is drawn at its bigger size. */
export const MAP_CLUSTER_LARGE_FROM = 10;

export interface MapClusterProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** How many calls the bubble stands for. Two or more. */
  count: number;
  /** What a screen reader says. Defaults to "{count} calls here". */
  label?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

/**
 * Several calls whose pins would overlap at the current zoom, as one dark
 * circle with the count in it. Clicking it closes in on those calls.
 *
 *   <MapCluster count={4} onClick={() => fit(group)} />
 */
export const MapCluster = React.forwardRef<HTMLButtonElement, MapClusterProps>(
  function MapCluster({ count, label, onClick, className, ...props }, ref) {
    const text = label ?? `${count} calls here`;
    return (
      <button
        ref={ref}
        type="button"
        aria-label={text}
        title={text}
        onClick={onClick}
        className={cn(
          mapClusterRecipe({
            size: count >= MAP_CLUSTER_LARGE_FROM ? 'lg' : 'sm',
          }),
          className
        )}
        {...props}
      >
        {count}
      </button>
    );
  }
);
